<div class="wrapper has-padding">
    <div class="width-500">
        {{message}}
    </div>
</div>
